/*
 * メインリスト
 */
<script>
	export default {
		mixins: [
			// 表示メッセージの管理
			require('js/common/message.mixin.vue'),
			// マネージャーインスタンスアクセス
			require('js/common/vuex/manager/read.mixin.vue'),
			// TABインデックス制御（Confirm版）
			require('js/common/tabIndexConfirm.mixin.vue'),
			// ウィンドウスクロール位置管理
			require('js/common/windowScroll.mixin.vue'),
		],
		props: {
			'r_messages':{
				required: true,
			},
			'r_type':{
				type:null,
				default:0
			},
			'r_initial_sortID':{
				tupe: Number,
				default: 1,
			},
			// 追加検索パラメータ
			'r_add_search_param':null,
			// 追加検索パラメータ
			'ignore_param':null,
			// その画面のメインのリストを明示的に指定
			'r_is_main_list':false,
		},
		data: function (){
			return {
				m_arrInfo: [],				// リストデータ
				m_arrAddInfo: [],			// リスト追加データ
				m_arrAddInfo2: [],			// 追加データ
				m_arrAddInfo3: [],			// 追加データ
				m_nAllInfoCnt:0,			// 全データ件数
				m_type: 0,					// 検索画面type

				m_strCodeName:"text_code",		// m_arrInfo から Codeを取り出す名前

				m_arrDispInfo:[],			// 表示用データ	※ 表示更新用
				m_bListChange:false,
				m_nSortID:1,
				m_oUsingStatusTarget: null,		// 使用状況表示対象データ
				m_bDispUsingStatus: false,		// 使用状況ダイアログ表示
				m_bDispErrorDetail: false,		// エラー詳細ダイアログ表示

				// 検索パラメータ
				m_arrLastSearchParam:{},		// 最新検索パラメータ
				m_pLastSearchResponse:null,		// 最新検索結果
				m_arrSrcInfo:null,

				// 表示パラメータ
				m_nPageNo:1,					// ページ番号
				m_nPageDispCnt:20,				// ページ表示件数

				m_arrAddSearchParam:{},			// 追加検索パラメータ
				m_is_pre_jump_callback: false,	// メインのリストの場合は値をtrueに書き換える 書き換えはコンストラクタで行う。

				m_jump_to_error_messasge: false,	// エラー時にメッセージの場所に移動するか

				m_forAutoReload: false,			// 自動リロード処理か
				m_messageDispType: 0,			// メッセージ表示方法

				m_errorTextEmbedItem:{
					code_label: this.r_messages.text_code,
					name_label: this.r_messages.disp_text,
					code_key: "text_code",
					name_key: "disp_text",
				},

				m_bEditAndOtherEdit: false		// 詳細ボタンを押下した行が新規/編集行かつ、他に新規/編集/削除業が存在するかどうか
			};
		},
		watch: {
			manager:function(){
				if(this.manager && this.m_is_pre_jump_callback){
					this.manager.setPreJumpCallback(this.onPreJump);
				}
			}
		},
		mounted: function(){
			if(this.r_type != undefined){
				this.m_type = this.r_type;
			}

			if(this.r_add_search_param){
				for( let key in this.r_add_search_param){
					this.m_arrAddSearchParam[key] = this.r_add_search_param[key];
				}
			}

			// 初期ソートの設定
			if(this.r_initial_sortID != 1){
				this.m_nSortID = this.r_initial_sortID;
			}
		},
		computed: {
			list_data:function(){
				return {"info":this.m_arrInfo,
						"add":this.m_arrAddInfo};
			},
			list_data_additional:function(){
				return this.m_arrAddInfo3;
			},
			/*
			 * ソートID取得
			 */
			sort_id: function() {
				return this.m_nSortID;
			},
			/*
			 * リスト表示判定
			 */
			is_list_disp: function() {
				return (this.m_arrInfo.length || this.m_nPageNo >1)?true:false;
			},
			/**
			 * 変更有無判定
			 */
			is_change_list:function(){
				return this.m_bListChange;
			},
			/**
			 * 画面遷移系動作用の変更有無判定
			 */
			is_change_list_for_pre_jump:function(){
				// 基本は変更有無判定と同じ
				// 必要に応じてオーバーライドする
				return this.is_change_list;
			},
			/**
			 * 新規追加ボタン disabled check
			 */
			is_disabled_add_btn:function(){
				return false;
			},
			/**
			 * コピー元選択
			 */
			is_copy_search:function(){
				return false;
			},
			/**
			 * 更新データが失われることの確認メッセージ for override
			 */
			msg_confirm_update_lost:function(){
				// r_messages が存在することが前提の実装
				return this.r_messages.confirm_update;
			},
			msg_confirm_move_details:function(){
				// r_messages が存在することが前提の実装
				// return this.m_bEditAndOtherEdit ? this.r_messages.confirm_move_details_edit_row : this.r_messages.confirm_move_details;
				return this.r_messages.confirm_update;
			},
			msg_confirm_move_delete:function(){
				// r_messages が存在することが前提の実装
				return this.r_messages.delete_check_text;
			},
			// 予約取り下げ確認メッセージ
			msg_confirm_discharge_res:function(){
				// r_messages が存在することが前提の実装
				return this.r_messages.msg_res_discharge_check_text;//
			},
			// 申請取り下げ確認メッセージ
			msg_confirm_discharge_app:function(){
				// r_messages が存在することが前提の実装
				return this.r_messages.msg_app_discharge_check_text;//
			},
			msg_yes_btn_name:function(){
				// r_messages が存在することが前提の実装
				return this.r_messages.yes_btn;
			},
			msg_no_btn_name:function(){
				// r_messages が存在することが前提の実装
				return this.r_messages.no_btn;
			},
			// アコーディオン
			if_accordion:function(){
				// v_accordion が存在することが前提の実装
				return this.$refs.v_accordion;
			},
			/**
			 * 呼び出しコードマックスミニマム取得
			 */
			search_default_codes:function(){
				var codes ={ max:0, min:0 };
				if(this.manager){
					codes = this.manager.getMaxMinCodes(this.m_type);
				}
				return { code_max:codes.max, code_min:codes.min };
			},
			/**
			 * 呼び出し名称マックス取得
			 */
			search_default_name_max:function(){
				var nameMax = 100;
				if (this.manager) {
					nameMax = this.manager.getNameMax(this.m_type);
				}
				return nameMax;
			},
			// 先頭固定要素数
			cnt_prefix:function(){
				return 0;
			}
		},
		methods: {
			// ソート方法の変更
			// 必ずこのメソッドを使用すること
			setSortID: function(sortID) {
				this.m_nSortID = sortID;
				// マネージャー側でソート情報を管理できる場合でメインリストからの変更ならば
				if (this.manager) {
					if (this.manager.setSortID) {
						if (this.r_is_main_list) {
							console.log("listBase setsortID to manager:" + sortID);
							this.manager.setSortID(sortID);
						}
					}
				}
			},
			clear: function(){
				this.setSortID(this.INITIAL_SORT_ID);
				this.m_nPageNo = 1;
				this.clearData();
			},
			//
			clearData:function(){
				this.m_arrInfo = [];
				this.m_arrAddInfo = [];
				this.m_arrAddInfo2 = [];
				this.m_arrAddInfo3 = [];
			},
			// 外部からのリスト検索要求 for override
			requestSearch: function(){
			},
			createSearchURL: function( param ){
				if(this.manager){
					return this.manager.createSearchURL( param ,this.m_type );
				}
				//console.log("createSearchURL : null");
				return "";
			},
			// リスト更新処理
			doSearch: function (param){
				console.log("----------------- listBase - doSearch : type=" + this.m_type)
				if(!this.manager)return;

				var url = this.createSearchURL( param, this.m_type );

				// URLを保存しておく
				this.m_arrLastSearchParam["url"] = url;
				this.m_arrLastSearchParam["param"] = param;

				// this.m_pLastSearchResponse=null;

				if (!this.m_forAutoReload) {
					// 表示メッセージをクリア
					this.clearMsg();
				}

				// ソートIDは動的に付加
				url = this.addSortIDToURL(url);

				//console.log("doSearch : " + url);

				var target = this;
				var callbackOK = function(rResponse){target.onSearchResponse(rResponse);}
				var callbackNG = function(rResponse){target.onSearchResponse(rResponse);}

				if (this.m_forAutoReload) {
					// ローディングを表示しない
					this.manager.notloadingAccess2(url,callbackOK,callbackNG)
				} else {
					this.manager.access(url,callbackOK,callbackNG);
				}
			},
			doReload: function(){
				console.log("---------------- listBase - doReload :");
				console.log(this.m_arrLastSearchParam);
				// URLを保存しておく
				var url = this.m_arrLastSearchParam["url"];
				if(url == null || url == undefined){
					url="";
				}

				this.clearMsg();

				// ページ要素&ソートIDは動的に付加
				url = this.addPageToURL(url);
				url = this.addSortIDToURL(url);

				var target = this;
				var callbackOK = function(rResponse){target.onSearchResponse(rResponse);}
				var callbackNG = function(rResponse){target.onSearchResponse(rResponse);}

				this.manager.access(url,callbackOK,callbackNG);
			},
			// ページ表示件数の取得 for Request
			getPageDispCount:function(nPageNo){
				if(this.m_nPageNo ==1 && this.cnt_prefix > 0){
					return this.m_nPageDispCnt - this.cnt_prefix;
				}
				return this.m_nPageDispCnt
			},
			// ページオフセットの取得 for Request
			getPageOffset:function(nPageNo){

				if(this.m_nPageNo > 1 && this.cnt_prefix>0 ){
					return ((this.m_nPageNo-1)*this.m_nPageDispCnt) - this.cnt_prefix;
				}
				return ((this.m_nPageNo-1)*this.m_nPageDispCnt);
			},
			// URLにページ要素を付加
			addPageToURL:function(url){
				var idx = url.indexOf("?");
				if(idx >0){
					url += "&";
				}else{
					url += "?";
				}
				url+="offset="+this.getPageOffset(this.m_nPageNo);
				url+="&count="+this.getPageDispCount(this.m_nPageNo);
				return url;
			},
			// URLにソート要素を付加
			addSortIDToURL:function(url){
				var idx = url.indexOf("?");
				if(idx >0){
					url += "&";
				}else{
					url += "?";
				}
				url+="sort=" +this.sort_id;
				return url;
			},
			// ソース情報の更新
			updateSrcInfo:function(){
				this.m_arrSrcInfo = this.convertResToDispData(this.m_pLastSearchResponse);
			},
			// 検索
			onSearchResponse: function(response){
				console.log("listBase - onSearchResponse : ");
				console.log(response);
				if (response.data["result"] == 300) {
					// CSV取込み処理（非同期）の結果
					return;
				}
				var isAutoLoaded = false;
				if (this.endAutoLoad) {
					// 自動ロード処理終了
					isAutoLoaded = this.endAutoLoad();
				}
				var isError = false;
				var isMessageDisplay = false;

				// 編集データをクリアする
				this.clearData();

				// リンク前コールバックをセット
				if(this.manager && this.m_is_pre_jump_callback){
					console.log("setPreJumpCallback");
					this.manager.setPreJumpCallback(this.onPreJump);
				}

				this.m_pLastSearchResponse = response;
				this.updateSrcInfo();
				if (response.data["result"] < this.RESULT_NUM) {
					var getCount;
					// 取得した長さ取得
					// @note レコードパターンによって変わる
					if (response.data.rec) {
						if (response.data.rec.length === undefined) {
							if (response.data.rec.data && response.data.rec.data.length !== undefined) {
								getCount = response.data.rec.data.length
							}
						} else {
							getCount = response.data.rec.length;
						}
					}
					if (response.data.rec && getCount != 0 && response.data.allcount > 0) {
						// データあり
						// 検索結果を表示用データに変換
						var infos = this.convertResToDispData(response);
						this.m_arrInfo = infos;
						this.m_nAllInfoCnt=Number(response.data.allcount);
					} else if(response.data.allcount > 0) {
						// データは存在するが、検索したpageにはデータがなかった。
						// データが存在する最終ページを指定して再検索を行う。
						this.m_nPageNo = Math.floor(response.data.allcount/this.m_nPageDispCnt); // 小数は切り捨て
						this.m_nPageNo += response.data.allcount%this.m_nPageDispCnt==0?0:1;
						this.doReload();
					} else {
						// 表示データなし
						this.m_arrInfo = [];
						this.m_nAllInfoCnt=Number(response.data.allcount);
						this.m_nPageNo = 1; // 検索データがないためpageを一ページ目に戻す。
						if(response.data.errmessage)
						{
							this.clearMsg(); // メッセージをクリア
							this.addInfoMsg(response.data.errmessage);
							isMessageDisplay = true;
						}
					}
					// 追加データ
					var addInfos = this.convertResToAddDispData(response);
					this.m_arrAddInfo = addInfos;
					if (response.data.addinfo) {
						this.m_arrAddInfo2 = response.data.addinfo;
					} else {
						this.m_arrAddInfo2 = [];
					}
					if (response.data.additionaldata) {
						this.m_arrAddInfo3 = response.data.additionaldata;
					} else {
						this.m_arrAddInfo3 = [];
					}
				} else {
					// エラー
					isError = true;
					this.m_nPageNo = 1;
					this.clearData();
					if(response.data.errmessage)
					{
						this.addErrMsg(response.data.errmessage);
						isMessageDisplay = true;
					}
				}
				if ((isAutoLoaded && this.m_messageDispType == 0) && !isMessageDisplay) {
					// 自動ロード処理が実行されていた場合は常に結果を表示する
					const mes = {'result':response.data.result,'message':response.data.errmessage}
					this.addInfoMsg(mes);
				}
				// リスト更新イベント
				this.onUpdateList();

				if (isError) {
					if (response.data) {
						// エラー後の処理 必要に応じてオーバーライドする
						this.afterListErrorOperation(response.data);
					}
				}
			},
			// エラー後の処理 必要に応じてオーバーライドする
			afterListErrorOperation: function(responseData) {
			},
			// 自動ロード終了 必要に応じてオーバーライドする
			endAutoLoad: function() {
				return false;
			},
			// 検索レスポンスを表示データに変換
			convertResToDispData: function(src){
				console.log("listBase - convertResToDispData : ");
				var infos = [];
				if(src && src.data && src.data.rec)
				{
					for (var key in src.data.rec) {
						var temp = this.addResToDispData(src.data.rec[key]);
						if(!temp.isDelete) {
							this.$set(temp,"isDelete",false);
							this.$set(temp,"isChange",false);
						}
						// ディープコピー
						var deepCopy = $.extend(true, {}, temp);
						infos.push( deepCopy );
					}
				}
				return infos;
			},
			// 検索レスポンスを表示データに変換
			convertResToAddDispData: function(src){
				console.log("listBase - convertResToAddDispData : ");
				var infos = [];
				if(src && src.data && src.data.addrec)
				{
					for (var key in src.data.addrec) {
						var temp = this.addResToDispData(src.data.addrec[key]);
						if(!temp.isDelete) {
							this.$set(temp,"isDelete",false);
							this.$set(temp,"isChange",false);
						}
						// ディープコピー
						var deepCopy = $.extend(true, {}, temp);
						infos.push( deepCopy );
					}
				}
				return infos;
			},
			/*
			 * 詳細ボタン
			 */
			onBtnDetail: function(info, isNew, idx){
				console.log('listBase - onBtnDetail : new=' + isNew);
				console.log(info);

				const callbackOK = function(){
					const dataDetail = this.createDetailData(info);
					if(isNew){
						// 新規行
						const infoEdit = this.manager.createNewData();
						this.requestDetailDisp(infoEdit, isNew, dataDetail);
					}else if(idx >= 0){
						// 既存行
						this.requestDetailDisp(this.getSrcItem(idx), isNew, dataDetail);
					}else{
						// 固定要素行
						this.requestDetailDisp(dataDetail, isNew, null);
					}
				}.bind(this);

				// 選択行以外で新規行、編集行、削除行いずれかが存在する場合は破棄確認を行ってから詳細画面に遷移する
				if(this.checkUpdate(info)){
					// 破棄確認ダイアログを表示する
					this.doCheckDialog(this.msg_confirm_move_details,
						function(){
							callbackOK();
							// 一覧の表示をクリアするために、キャンセルボタンの処理を呼びだす
							this.onCancel();
						}.bind(this)
					);
				}else{
					// 存在しない場合はそのまま詳細画面に遷移する
					callbackOK();
				}
			},
			doBtnDetail: function(dataDetail, isNew){
				console.log("listBase - doBtnDetail : new=" + isNew);
				console.log(dataDetail);
				var target = this;
				var code1;
				var code2;
				var code3;
				// 絞り込み条件のメイン
				if (dataDetail.depart_code) {
					code3 = dataDetail.depart_code;
				} else if (dataDetail.company_code) {
					// 部門
					code3 = dataDetail.company_code;
				} else if (dataDetail.agency_code) {
					// 代理店拠点
					code3 = dataDetail.agency_code;
				} else {
					code3 = 0;
				}
				// メインキーコード
				if (dataDetail.text_code) {
					code1 = dataDetail.text_code;
				} else if (dataDetail.plu_code) {
					code1 = dataDetail.plu_code;
				} else {
					// 機種
					code1 = dataDetail.machine_model_code;
				}
				// サブキーコード
				if (dataDetail.type) {
					code2 = dataDetail.type;
				} else if (dataDetail.text_sub_code) {
					code2 = dataDetail.text_sub_code;
				} else {
					code2 = 1;
				}

				// aaaaaa この引数に更新後のデータを渡してやれば良さそう
				// 以下の処理をcallbackにして、実行するべき？
				var set_callback = function(param){target.requestDetailDisp(param,isNew,null);}
				var callback = function(){target.sendRefresh(code1, code2, code3, set_callback, dataDetail)};
				// 更新に行った後詳細画面を開く
				this.doUpdateDetail(callback);
			},

			/**
			 * 最新のデータを取得。
			 */
			sendRefresh: function(code,code2,depart_code,set_callback,dataDetail){
				// if(!code){// 必須
				// 	return false;
				// }

				var url = "";
				// if ( this.r_settings.apply_mode == 2 ) {
				url = this.manager.createRefreshURL(depart_code,code,code2,this.m_type);
				// } else {
				// 	url = this.manager.createApplyNextURL(this.r_class_code,this.r_info.id,0,this.m_type);
				// }

				var target = this;
				var callbackOK = function(rResponse){
					target.m_isNetwork = true;
					var data = target.manager.convertRefreshResponse(rResponse,target.m_type);
					//var detail_data = this.createDetailData( data );
					// data = data ? data : dataDetail;
					data = $.extend(true, dataDetail, data);

					set_callback(data);

					// target.onRefreshEnd(0, data, null);
				}
				var callbackNG = function(rResponse){
					target.m_isNetwork = +rResponse.data["result"]==target.manager.ERR_CODE?false:true;

					// target.$emit("event_refresh_end",1, rResponse, rResponse.data.errmessage);
					// target.onRefreshEnd(1, rResponse, rResponse.data.errmessage);
				}

				this.manager.access(url,callbackOK,callbackNG);
				return true;
			},
			/**
			 * 更新処理の終了
			*/
			onRefreshEnd: function(retcode, data, msg, bNew=false){
				if(retcode == 0){// 成功
					// this.setSuccessMessage(msg);
					if ( data ) { // データが存在する
						this.m_info = this.$refs.func.convertInitData(data);
						if(bNew){
						// 初期化データを生成セットしたい場合は、初期化データが飛んでくる
							this.m_bNew = true;
						}else{
							this.m_bNew = false;
						}
					} else {
						// データが存在しないため新規として扱う
						this.m_info = this.$refs.func.reset();
						if ( this.m_bResetCode2 && !this.m_bNew) { // 新規フラグがファルスでかつコード2resetフラグが立っていた場合にコード２をresetする。
							this.m_strCode2 = this.$refs.func.resetCode2(this.m_strCode2);
						}
						this.m_bNew = true;
					}
				}else{ // エラー処理
					this.setErrorMessage( msg )
				}
				// コード2resetフラグは必ずresetする。
				this.m_bResetCode2 = false;
			},
			/**
			 * 詳細ボタンを押下したときに渡すデータを生成。
			 * 個別処理が必要ならオーバーライドする。
			 */
			createDetailData:function( info ) {
				// ディープコピーを生成して返す
				return $.extend(true,{},info);
			},
			/*
			 * 詳細ボタン押下時の変更チェック
			 * 詳細画面を開くと編集データが失われるため、先に保存する必要があるかをチェックする
			 */
			checkUpdate: function( avoid ) {
				if(this.is_copy_search){
					return false;
				}

				var idxAvoid = -1;
				if(avoid){
					idxAvoid = this.m_arrInfo.indexOf(avoid);
				}
				var cnt = this.m_arrInfo.length;
				for(var i=0;i<cnt;i++){
					if(i == idxAvoid){
						continue;
					}
					if(this.m_arrInfo[i].isChange ||
						this.m_arrInfo[i].isDelete){
						//console.log("[ checkUpdate ]");
						//console.log(this.m_arrInfo);
						return true;
					}
				}
				return false;
			},
			/**
			 * 検索ボタン押下時の処理 for override
			 */
			onBtnSearch: function(param, isSearchBtn){
				//console.log("onBtnSearch");
				// 更新があるなら更新確認をする
				if (this.is_change_list) {
					var target = this;
					var callback = function(){target.onSearch(param,isSearchBtn);}
					// 確認ダイアログを表示し、OKならばリストを更新する。
					this.doCheckDialog(this.msg_confirm_update_lost,callback);
				} else {
					// 検索処理の実行
					this.onSearch(param, isSearchBtn);
				}
			},
			/**
			 * 検索処理の実行
			 */
			onSearch: function(param,isSearchBtn){
				console.log("--------------- listBase - onSearch :");
				// ページは1に変更
				this.m_nPageNo=1;
				// r_is_copy_searchを引数として受け取っていることを前提としている。
				if ( !this.r_is_copy_search && this.if_accordion && isSearchBtn ) {
					this.if_accordion.closeList();
				}
				// 検索パラメータの追加処理
				param = this.addSearchParam(param);
				if (this.r_is_copy_search) {
					// コピー用の場合のパラメータ
					param["search_for_copy"] = 1;
				}
				console.log("searchParam:");
				console.log(param);
				this.doSearch(param);
			},
			// 検索に必要なパラメータを追加する
			addSearchParam: function(param){
				if(!param)
				{
					param = {};
				}
				param["offset"] = this.getPageOffset(this.m_nPageNo);
				param["count"] = this.getPageDispCount(this.m_nPageNo);

				for( var key in this.m_arrAddSearchParam )
				{
					if ( param[key] ) {
						// データが存在する
					} else {
						// データが存在しない
						param[key] = this.m_arrAddSearchParam[key];
					}
				}
				return param;
			},
			clearAddSearchParam:function(){
				this.m_arrAddSearchParam = {};
			},
			// 追加パラメータを設定
			setAddSearchParam(key , val){
				this.m_arrAddSearchParam[key]=val;
			},
			/*
			 * キャンセルボタン
			 */
			onBtnCancel: function( event ) {
				var result = true;
				if ( this.is_change_list ) {
					var target = this;
					var callback = function(){target.onCancel();}
					// 確認ダイアログを表示し、OKならばリストを更新する。
					this.doCheckDialog(this.msg_confirm_update_lost,callback);
				} else {
					this.onCancel();
				}
			},
			/*
			 * キャンセル処理
			 */
			onCancel: function() {
				this.m_arrInfo = $.extend(true,[],this.m_arrSrcInfo);
				// メッセージクリア
				this.clearMsg();
			},
			/*
			 * エラー行数チェック
			 */
			createMessage:function(request, data, newDetailpIndex = -1, oldDetailpIndex = -1 ) {
				console.log("createMessage : Code Name=" + this.m_strCodeName);

				var message = $.extend(true, {}, data);
				var index = 0;

				if(data.rec)
				{
					for (; index < data.rec.length; index ++) {
						for (var infoIndex in this.m_arrInfo) {
							if (data.rec[index].code != undefined &&
								data.rec[index].code == this.m_arrInfo[infoIndex][this.m_strCodeName]){
								message.rec[index].idx = Number(infoIndex) + 1;
								message.rec[index].name = this.m_arrInfo[infoIndex][this.m_errorTextEmbedItem.name_key];
								message.rec[index].code_label = this.m_errorTextEmbedItem.code_label;
								message.rec[index].name_label = this.m_errorTextEmbedItem.name_label;
							}
						}
					}
				}
				return message;
			},
			// 共通処理
			/*
			 * 更新ボタン
			 */
			onBtnUpdate:function() {
				// スクロール位置を保存
				// this.saveScrollOffset();

				if ( this.is_change_list ) {
					var target = this;
					var callback = function(){target.doReload();}
					// 確認ダイアログを表示し、OKならばリストを更新する。
					this.doCheckDialog(this.msg_confirm_update_lost,callback);
				} else {// 更新する
					this.doReload();
				}
			},
			/*
			 * ソートボタン
			 */
			onBtnSort:function(sortID) {
				// スクロール位置を保存
				// this.saveScrollOffset();

				if ( this.is_change_list ) {
					var target = this;
					var callback = function(){target.doSort(sortID);}
					// 確認ダイアログを表示し、OKならばリストを更新する。
					this.doCheckDialog(this.msg_confirm_update_lost,callback);
				} else {//
					this.doSort(sortID);
				}
			},
			doSort:function(sortID) {
				this.m_nPageNo = this.INITIAL_PAGE_NO;
				this.setSortID(sortID);
				this.doReload();
			},
			/*
			 * 詳細画面表示用データを更新
			 */
			requestDetailDisp:function( info, isNew, infoEdit) {
				// オンラインかどうかを確認するためダミーURLにアクセス
				var urlDummy = this.manager.createDummyURL();
				const callbackOK = function(rResponse){
					this.$emit("event_detail",info, isNew, infoEdit);
				}.bind(this);
				const callbackNG = function(rResponse){
					this.addErrMsg(rResponse.data.errmessage);
				}.bind(this);
				this.manager.access(urlDummy,callbackOK,callbackNG);
			},
			/**
			 * 更新データ作成処理(既存分)
			 */
			createUpdateDataArray:function() {
				var arr = [];

				console.log("listBase - createUpdateDataArray : ");

				// 登録データを変更
				for (var index =0;index < this.m_arrInfo.length; index++) {
					if ( this.checkItemChange( index )) {// 変更があるならば
						var update_type = this.m_arrInfo[index].isDelete ? this.UPDATE_TYPE_DEL : this.UPDATE_TYPE_UP;
						var temp = $.extend(true,{},this.m_arrInfo[index]);
						arr.push( this.manager.createUpdateData(temp,
																update_type, this.m_type) );
					}
				}
				return arr;
			},
			/**
			 * 更新データ作成処理(追加分)
			 */
			createAddDataArray:function() {
				return [];
			},
			/**
			 * 指定された行が編集行、削除行かチェックする
			 */
			checkItemChange: function(index){
				return this.m_arrInfo[index].isChange || this.m_arrInfo[index].isDelete;
			},
			/**
			 * 詳細更新処理
			 */
			doUpdateDetail: function(callback) {
				var target = this;
				var okCallback = function(param){
					var url = target.manager.createUpdateURL(target.UPDATE_TYPE_UP,target.m_type);
					if ( param.length > 0 ) {
						// 更新情報がある場合、ポストしてから詳細画面を開く
						var callbackOK = function(rResponse){
							target.addInfoMsg(rResponse.data.errmessage);
							// 画面更新
							target.doReload();
							// コールバック呼び出し
							callback();
						}
						var callbackNG = function(rResponse){
							// 更新に失敗
							// エラーメッセージを表示する
							target.addErrMsg(target.createMessage(param, rResponse.data));
							// 表示したエラーメッセージへジャンプする
							target.jumpToErrMessage();
						}
						target.manager.post(url,param,callbackOK,callbackNG);
					} else {
						// 更新情報がない場合はそのままコールバック呼び出し
						callback();
					}
				};
				this.doUpdate(okCallback);
			},
			/**
			 * 確定ボタン
			 */
			onBtnConfirm:function() {
				console.log("onBtnConfirm : ");
				var target = this;
				var okCallback = function(param){
					target.manager.sendUpdateRequest(param, target.onUpdateResponse, target.m_type);
				};

				this.doUpdate(okCallback);
			},
			/**
			 * update処理
			 * 削除データがある場合は更に確認を行うので、そこでキャンセルした場合の処理が必要ならばcancelCallbackで定義
			 */
			doUpdate:function(callback, cancelCallback = null) {
				console.log("doUpdate : ");
				console.log(this.m_arrInfo);

				// 新規追加分
				var arrAdd = this.createAddDataArray();
				// 登録データ分
				var arrData = this.createUpdateDataArray();
				// 削除が含まれているか
				var isDelete = this.checkDelete(arrData);

				var param = arrAdd.concat(arrData);

				// メッセージクリア
				this.clearMsg();
				var data = this.manager.validate(param, this.m_type);
				if ( data.result > 0 ) {
					// バリデーションエラー
					// エラーメッセージを表示する
					this.addErrMsg(this.createMessage(param, data));
					// 表示したエラーメッセージへジャンプする
					this.jumpToErrMessage();
					return;
				}
				var target = this;

				var okCallback = function(){
					callback(param)
				};

				if (isDelete) {
					this.doCheckDialog(this.msg_confirm_move_delete, okCallback, cancelCallback);
				} else {
					okCallback();
				}
			},
			// 削除データcheck
			checkDelete: function(arrData){
				var isDelete = false;
				for (var index in arrData) {
					if ( arrData[index].update_type == this.UPDATE_TYPE_DEL ) {
						isDelete = true;
						break;
					}
				}
				return isDelete;
			},
			// 更新レスポンス
			onUpdateResponse: function(result, param, response){
				if (result == 0) {
					this.addInfoMsg(response.data.errmessage);
					this.nextMsgNotClear();
					this.doReload();
				} else {
					// エラーメッセージを表示する
					this.addErrMsg(response?this.createMessage(param, response.data):param);
					if (this.m_jump_to_error_messasge) {
						// 表示したエラーメッセージへジャンプする
						this.jumpToErrMessage();
					}
				}
			},
			/**
			 * リスト更新イベント for override
			 */
			onUpdateList: function(){
				this.m_bListChange = this.checkUpdate(null);
			},
			/**
			 * 表示情報追加 for override
			 */
			addResToDispData: function(src){
				return src;
			},
			/**
			 * 変更前データ取得 <br>
			 * ******* 内部処理 *******<br>
			 * vuexのリストから変更前データをコピーし、リターンする。<br>
			 *
			 * @function getSrcItem
			 * @param {number} nIndex - 取得データID
			 * @instance
			 */
			getSrcItem: function(nIndex) {
				// 検索結果を表示用データに変換
				if(!this.m_arrSrcInfo){
					return {};
				}
				var infos = this.m_arrSrcInfo;
				return $.extend(true,{},infos[nIndex]);
			},
			getSrcInfoArray: function() {
				// 検索結果を表示用データに変換
				return this.m_arrSrcInfo;
			},
			// データが変更されたか確認する際に無視するアイテム（オーバーライド用）
			getChangeIgnoreItem: function() {
				return {};
			},
			// 外部取得テキスト取得
			getExternalText: function() {
				var target = this;
				var result = '';

				// var lastDate = null;
				// var currentDate = null;
				$.each(this.m_arrSrcInfo, function(i, row) {
					switch (target.r_settings.user.display_id) {
						// 稼働実績
						case '020000000000':
							if (row.select_target_cl != null && row.last_get_data_timestamp) {
								result = '';
								// 対象選択 (0:IoT稼働製品、1:全てのIoT対象製品)
								if (row.select_target_cl == 0) {
									result += '[' + target.r_messages.select_iot_product + ']';
								} else if (row.select_target_cl == 1) {
									result += '[' + target.r_messages.select_all_product + ']';
								}
								// 更新日時
								result += '<br>';
								result += (target.r_messages.as_of) ? target.r_messages.as_of + ' ' : '';
								result += row.last_get_data_timestamp;
								return false;
							}
							break;
						// その他
						default:
							if (row.last_get_data_timestamp) {
								result = '';
								// 更新日時
								result += (target.r_messages.as_of) ? target.r_messages.as_of + ' ' : '';
								result += row.last_get_data_timestamp;
								return false;
							}
							break;
					}
				});

				return result;
			},
			/**
			 * 使用状況表示ボタン押下
			 */
			onBtnUsingStatus: function(info){
				this.m_target = info;
				this.m_bDispUsingStatus = true;
			},
			/**
			 * 使用状況ダイアログ×ボタン押下
			 */
			onBtnCloseUsingStatus: function(){
				this.m_target = null;
				this.m_bDispUsingStatus = false;
			},
			/*
			 * 消去フラグ変更
			 */
			onBtnDelete: function(info) {
				if(info.isDelete)
				{
					info.isDelete = false;
				}
				else{
					info.isDelete = true;
				}
				// this.onUpdateList();
			},
			// ページ変更イベント
			onChangePage: function(nPage){
				// 更新確認
				var result = true;
				if ( this.is_change_list ) {
					var target = this;
					var callback = function(){target.doChangePage(nPage);}
					// 確認ダイアログを表示し、OKならばリストを更新する。
					this.doCheckDialog(this.msg_confirm_update_lost,callback);
				} else {
					this.doChangePage(nPage);
				}
			},
			// ページ変更実行
			doChangePage: function(nPage){
				this.m_nPageNo = nPage;
				this.doReload();
				this.jumpAfterChangePage();
			},
			// 表示件数変更
			onChangeCount: function(nCount,ngCallback){
				// スクロール位置を保存
				// this.saveScrollOffset();

				// 更新確認
				if ( this.is_change_list ) {
					var target = this;
					var okCallback = function(){target.doChangeCount(nCount);}
					// 確認ダイアログを表示し、OKならばリストを更新する。
					this.doCheckDialog(this.msg_confirm_update_lost,okCallback,ngCallback);
				}else {
					this.doChangeCount(nCount);
				}
			},
			doChangeCount: function(nCount){
				this.m_nPageNo = 1;
				this.m_nPageDispCnt = nCount;
				this.doReload();
			},
			// エラーメッセージへの タグジャンプ
			jumpToErrMessage:function(){
				// スクロールの速度
				var speed = 400; // ミリ秒
				// 移動先を取得
				var target = $("#disp-err-msg");
				if(target.length){
					// 移動先を数値で取得
					var position = target.offset().top - 50;

					// スムーススクロール
					$('body,html').animate({scrollTop:position}, speed, 'swing');
				}else{
					// 移動対象が見つからない
					console.log("target none.");
				}
			},
			// ページ遷移後のタグジャンプ
			jumpAfterChangePage: function(){
				// スクロールの速度
				const speed = 400; // ミリ秒
				// 対象を取得
				const bodyContainer = $(".body-container:last");

				if(bodyContainer.length){
					// ダイアログの場合
					// 移動先を数値で取得
					const paging = $(".body-container:last .paging:first");
					const marginTop = Number($(paging).css('margin-top').replace('px', ''));
					const borderTop = Number($(paging).css('border-top').replace('px', ''));
					const paddingTop = Number($(paging).css('padding-top').replace('px', ''));

					let position = bodyContainer.scrollTop() + paging.offset().top - bodyContainer.offset().top;
					if(!isNaN(marginTop)){
						position -= marginTop;
					}
					if(!isNaN(borderTop)){
						position -= borderTop;
					}
					if(!isNaN(paddingTop)){
						position -= paddingTop;
					}

					// スクロール位置復元を実行しない
					this.m_bRestoreScroll = false;
					// スムーススクロール
					bodyContainer.animate({scrollTop:position}, speed, 'swing');
				}else{
					// 一覧の場合
					// 移動先を数値で取得
					const paging = $(".paging:first");
					const marginTop = Number($(paging).css('margin-top').replace('px', ''));
					const borderTop = Number($(paging).css('border-top').replace('px', ''));
					const paddingTop = Number($(paging).css('padding-top').replace('px', ''));

					let position = paging.offset().top;
					if(!isNaN(marginTop)){
						position -= marginTop;
					}
					if(!isNaN(borderTop)){
						position -= borderTop;
					}
					if(!isNaN(paddingTop)){
						position -= paddingTop;
					}

					// スクロール位置復元を実行しない
					this.m_bRestoreScroll = false;
					// スムーススクロール
					$('body,html').animate({scrollTop:position}, speed, 'swing');
				}
			},
			/*
			 * 確認ダイアログを表示する。
			 * OKボタンが押された場合コールバックを呼ぶ。
			 */
			doCheckDialog: function(msg_confirm, okCallback, ngCallback = null) {
				// アクティブな要素のフォーカスを外す
				this.blurActiveElement();
				var target = this;
				var isClicked = false;
				$.confirm({ // 確認ダイアログを表示する。
					title: '',
					content: msg_confirm,
					buttons: {
						ok: {
							text: this.msg_yes_btn_name,
							btnClass: 'btn-ok',
							action: function() {
								if (isClicked) return; // ダブルクリック抑制
								isClicked = true;
								okCallback();
							}
						},
						cancel: {
							text: this.msg_no_btn_name,
							btnClass: 'btn-cancel',
							action: function() {
								if ( ngCallback != null ) {
									ngCallback();
								}
							}
						}
					},
					onOpen: function(){
						target.toggleTabIndexConfirm(true);
					},
					onClose: function(){
						target.toggleTabIndexConfirm(false);
					},
				});
			},
			onEventBtnDetail:function(dat){
				this.onBtnDetail(dat.info,dat.flag,dat.idx);
			},
			onEventBtnSort:function(dat){
				this.onBtnSort(dat);
			},
			onEventBtnDelete:function(dat){
				this.onBtnDelete(dat);
			},
			onEventBtnChange:function(dat){
				this.onBtnChange(dat);
			},
			onEventUsingStatus: function(dat){
				this.onBtnUsingStatus(dat);
			},
			onChangeClassName:function(dat){
				this.$emit("change_class_name",dat);
			},
			// リンクジャンプ前コールバック
			onPreJump:function(success,failed){
				if ( this.is_change_list_for_pre_jump ) {
					// 更新あり
					// 確認ダイアログ表示
					this.doCheckDialog(this.r_messages.confirm_update,success,failed);
					return;
				}
				success();
			},
			blurActiveElement: function() {
				// アクティブな要素のフォーカスを外す
				document.activeElement.blur();
			},
			padZero:function(num, len){
				return ( Array(len).join('0') + num ).slice( -len );
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/list/listBase.mixin.vue